export default {
  name: 'ColumnItem',
  components: {
    RenderDom: {
      functional: true,
      // 函数式组件 - 无 data 和 this 上下文 => better render
      props: {
        row: Object,
        index: Number,
        datakey: String,
        render: Function,
        ellipsis: Boolean
      },
      /**
         * @param {Function} createElement - 原生创建dom元素的方法， 弃用，推荐使用 jsx
         * @param {Object} ctx - 渲染的节点的this对象
         * @argument 传递参数 row index
         */
      render(ctx, createElement) {
        //   console.log('render///', ctx, arguments)
        const {
          row,
          index,
          datakey
        } = ctx;
        const renderContent = ctx.render(row[datakey], row, index) || '';
        return renderContent; // typeof renderContent === 'string' ? createElement('span', renderContent) : renderContent
      }
    }
  },
  props: {
    cols: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  data() {
    return {};
  },
  computed: {
    bindAttrs() {
      return this.columnbindAttr(this.cols);
    }
  },
  watch: {},
  mounted() {},
  methods: {
    firstWordUpperCase(str) {
      const sa = str.toLowerCase().split('');
      sa[0] = sa[0].toUpperCase();
      return sa.join('');
    },
    columnbindAttr(cols) {
      let options = {};
      for (let t in cols) {
        if (t === 'groups' || t === 'scopedSlots' || t === 'render') {
          continue;
        } else if (t.includes('-')) {
          let newkey = '';
          let key = t.split('-');
          key.forEach((el, index) => {
            if (index === 0) {
              newkey += el;
              return;
            }
            newkey += this.firstWordUpperCase(el);
          });
          options[newkey] = cols[t];
        } else if (t === 'key') {
          options.prop = cols[t];
          options[t] = cols[t];
        } else {
          options[t] = cols[t];
        }
      }
      if (!options.align) {
        options.align = 'center';
      }
      return options;
    }
  }
};